import "core-js/modules/es.function.name";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import useTranslate from '@sprinx/react-globalize/useTranslate';
import ProductListItemImage from '../ProductListItemImage';
import ProductListItemDetailLink from '../ProductListItemDetailLink';
import ProductListItemCard from '../ProductListItemCard';

var DefaultProductListItem = function DefaultProductListItem(_ref) {
  var currency = _ref.currency,
      product = _ref.product,
      rest = _objectWithoutProperties(_ref, ["currency", "product"]);

  var t = useTranslate();
  return /*#__PURE__*/React.createElement(ProductListItemCard, rest, /*#__PURE__*/React.createElement(ProductListItemImage, {
    product: product,
    view: 'card',
    size: "big"
  }), /*#__PURE__*/React.createElement(ProductListItemDetailLink, {
    href: product.href
  }, t(product.name)));
};

DefaultProductListItem.propTypes = {
  currency: PropTypes.string.isRequired,
  product: PropTypes.shape({
    href: PropTypes.string,
    name: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired
};
export default DefaultProductListItem;